module.exports = __webpack_public_path__ + "img/diamonds-1@2x.6f81e1d.webp";